import { useTheme } from "@emotion/react";
import { Button, Typography, useMediaQuery } from "@mui/material";
import { useClient } from "../../../context/ClientContext";
// Updated OptionButton component to ensure center alignment


export const ClientOptionButton = ({ option, onClick, optionSx, optionBtnSx, isSelected, optionSelectSingleValue, value }) => {
    const { theme } = useClient();
    //this style will be applicable for show selected options by user (onclick of back state)
    const preSelectStyleForSlectedSinglevalue = {
        borderRadius: '10px',
        backgroundColor: theme.optionsButtonCSS.buttonBgColorOnHOver ,
        color: theme.optionsButtonCSS.buttonTextColorOnHOver , 

    }
    const isSingleOptionSelected = optionSelectSingleValue === value;

    // const theme = useTheme();
    // const isLaptopUp = useMediaQuery(theme.breakpoints.up('md'));


    return (
        <Button
            sx={{
                width: {
                    xs: '280px',
                    sm: '300px',
                    md: '400px',
                    lg: '450px'
                },
                height: {
                    xs: '54px',
                    md: '60px',
                    sm: "60px",
                    lg: "60px"
                },
                backgroundColor : isSelected ? theme.optionsButtonCSS.buttonBgColorOnHOver :  theme.optionsButtonCSS.buttonBgColor ,
                marginBottom : "10px",
                borderRadius: isSelected ? '10px' : "0px",
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: isSelected ? theme.optionsButtonCSS.buttonTextColorOnHOver : theme.optionsButtonCSS.buttonTextColor, 
                mx: 'auto', // Added to ensure center alignment
                borderRadius: '10px',
                ...(!isSelected && isSingleOptionSelected ? preSelectStyleForSlectedSinglevalue : {}),
                '&:hover': {
                    transform: 'translateY(-2px)',
                    backgroundColor:  theme.optionsButtonCSS.buttonBgColorOnHOver,
                    color:  theme.optionsButtonCSS.buttonTextColorOnHOver,
                    borderRadius: '10px',
                },
                ...optionBtnSx
            }}
            onClick={onClick}
        >
            <Typography
                sx={{
                    fontSize: {
                        xs: '14px',
                        sm: '15px',
                        md: '16px'
                    },
                    fontWeight: '500',
                    lineHeight: '22.5px',
                    textAlign: 'center',
                    width: '100%',
                    ...optionSx
                }}
            >
                {option}
            </Typography>
        </Button>
    );
};